import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import VendorCard from '@/components/VendorCard'

export default function Broadcasters() {
  // Fetch all broadcaster vendors
  const { data: broadcasters, isLoading } = useQuery({
    queryKey: ['broadcasters'],
    queryFn: async () => {
      try {
        // Get vendors where vendor_type is 'broadcaster'
        const { data, error } = await supabase
          .from('vendors')
          .select(`
            id,
            user_id,
            vendor_name,
            vendor_description,
            vendor_email,
            vendor_phone,
            vendor_logo_url
          `)
          .eq('vendor_type', 'broadcaster')
          .order('vendor_name', { ascending: true })

        if (error) {
          console.warn('Error fetching broadcasters:', error)
          return []
        }

        // Add user_id and vendor_type to each vendor for navigation
        return (data || []).map((vendor: any) => ({
          ...vendor,
          user_id: vendor.user_id,
          vendor_type: 'broadcaster',
        }))
      } catch (err) {
        console.warn('Error in broadcasters query:', err)
        return []
      }
    },
    retry: false,
  })

  if (isLoading) {
    return (
      <div className="max-w-6xl mx-auto">
        <p style={{ color: 'var(--text-primary)' }}>Loading broadcasters...</p>
      </div>
    )
  }

  return (
    <div className="max-w-6xl mx-auto">
      <h1 
        className="text-3xl font-bold mb-6"
        style={{ color: 'var(--text-primary)' }}
      >
        Broadcasters
      </h1>

      {!broadcasters || broadcasters.length === 0 ? (
        <p style={{ color: 'var(--text-primary)' }}>
          No broadcasters available.
        </p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {broadcasters.map((broadcaster) => (
            <VendorCard key={broadcaster.id} vendor={broadcaster} />
          ))}
        </div>
      )}
    </div>
  )
}

